
import "./components/common/LazyImg";
import Splide from '@splidejs/splide';

/**
 * This is our clientside javascript entry point
 */

// The Ceres bundle provides Vue, we do not need to bundle it ourself
const Vue = window.Vue;
var initShopbuilderScripts = false;

$(document).on("shopbuilder.before.viewUpdate shopbuilder.after.viewUpdate", function(event, eventData, widgetElement)
{
    if(!initShopbuilderScripts){
        initShopbuilderScripts = true;
    }
    
});

window.homeSliderElement = null;
function initHomeSlider(withAutoplay){
    console.log(withAutoplay)
    console.log("withAutoplay")
    if(homeSliderElement != null){
        homeSliderElement.destroy();
    }

    
    var initHomeSlider = false;
    var homeSliderInterval = setInterval(function () {
        if($('.splide-slider').length > 0 && !initHomeSlider){         
            initHomeSlider = false;
            $('.splide-slider').each(function(){
                homeSliderElement = new Splide(this,{
                    mediaQuery: 'min',
                    type   : 'loop',
                    pagination: true,
                    arrows: false,
                    perPage: 1,
                    perMove: 1,
                    autoplay: withAutoplay,
                    speed: 1500,
                    reducedMotion: {
                        interval: 4000,
                        
                        autoplay: "play"
                    },
                    breakpoints:{
                        1200: {
                            arrows: true
                        },
                    }
                }).mount();
            })
            clearInterval(homeSliderInterval); 
        }
    }, 100);
}
$(document).ready(function(){

    if(!vueApp.$ceres.isShopBuilder){
        initHomeSlider(true);
    }
    
})
$(document).on("shopbuilder.after.drop shopbuilder.after.widget_replace", function(event, eventData, widgetElement)
{
   if($(widgetElement).hasClass('splide-slider')){
        initHomeSlider(false);
   }
});